module.exports = {
    SET_SELECTED_PRODUCTS: 'SET_SELECTED_PRODUCTS',
    SET_RESULTS_SELECTION: 'SET_RESULTS_SELECTION',
    SET_EXPECTED_PRICE: 'SET_EXPECTED_PRICE',
    SET_REPRICING_LOG: 'SET_REPRICING_LOG',
    SET_USER_LOGGED: 'SET_USER_LOGGED',
    SET_SHOPPING_CART: 'SET_SHOPPING_CART',
    SET_PRIME_MEMBER_SELECTED: 'SET_PRIME_MEMBER_SELECTED',
    SET_USER_STATUS: 'SET_USER_STATUS',
    UPDATE_MEMBERSHIP_SUBSCRIPTION: 'UPDATE_MEMBERSHIP_SUBSCRIPTION',
    SET_BOARDING_OPTIONS: 'SET_BOARDING_OPTIONS',
    SET_SELECTED_PAYMENT_METHOD: 'SET_SELECTED_PAYMENT_METHOD',
    SET_TRAVELLER_ID: 'SET_TRAVELLER_ID',
    SET_MEMBERSHIP_SUBSCRIPTION_OFFER: 'SET_MEMBERSHIP_SUBSCRIPTION_OFFER',
    SET_MEMBERSHIP_DISCOUNT: 'SET_MEMBERSHIP_DISCOUNT',
    SET_RESIDENT_DISCOUNT: 'SET_RESIDENT_DISCOUNT',
    TOGGLE_RESIDENT_DISCOUNT: 'TOGGLE_RESIDENT_DISCOUNT',
    SET_RISKY_CREDIT_CARD: 'SET_RISKY_CREDIT_CARD',
    SET_EXPIRING_CREDIT_CARD: 'SET_EXPIRING_CREDIT_CARD',
    SET_MEMBERSHIP_CHURN_RISK: 'SET_MEMBERSHIP_CHURN_RISK',
    SET_PRICE_SELECTED_RESULTS: 'SET_PRICE_SELECTED_RESULTS',
    SET_REPRICING_AMOUNT: 'SET_REPRICING_AMOUNT',
    SET_MEMBERSHIP_INFO: 'SET_MEMBERSHIP_INFO',
    SET_BAG_MERCHANDISE_INFO: 'SET_BAG_MERCHANDISE_INFO',
    SET_IS_META: 'SET_IS_META',
    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
    SET_YEARLY_REJECTED: 'SET_YEARLY_REJECTED',
};
